// extracted by mini-css-extract-plugin
export default {"root":"DeleteModal_root__eIhVq","container":"DeleteModal_container__MDtK2"};